import {$, w} from './constants';

w.load(() => {
	// console.log('Hello world from El Cultivo! --Load');
});

$(document).ready(function() {

	// Mobile menu
	$('.menu_btn_JS').click(function () {
		$('.menu_JS').fadeIn('fast')
	})
	$('.menu_close_JS').click(function () {
		$('.menu_JS').fadeOut('fast')
	})

	// Homepage smooth scroll behavior
	$('.nav_JS a[href*="#"]').on('click', function(e) {
		const url = new URL(this.href);
		const currentUrl = window.location.origin + window.location.pathname;

		if (currentUrl === url.origin + url.pathname) {
			e.preventDefault();
			const targetId = url.hash.substring(1);
			const target = document.getElementById(targetId);
			if (target) {
				target.scrollIntoView({ behavior: 'smooth' });
			}
		}
	});

	// Hide mobile menu while navigating
	$('.nav_home_JS a').on('click', function(e) {
		$('.menu_JS').fadeOut('fast')
	});


	// Logo scroll toggle
	function checkScroll() {
		const scrollLimit = $(window).width() <= 720 ? 135 : 200;

		if ($(window).scrollTop() >= scrollLimit) {
			$('.header_logo_JS').removeClass('hide');
		} else {
			$('.header_logo_JS').addClass('hide');
		}
	}
	checkScroll();
	$(window).on('scroll resize', checkScroll);

	// Cronograma Slider
	$('.crono_slider_JS').slick({
		dots: false,
		infinite: false,
		speed: 300,
		slidesToShow: 1,
		centerMode: false,
		variableWidth: true,
		prevArrow: $('.crono_slider_prev_JS'),
		nextArrow: $('.crono_slider_next_JS')
	});

	// Temas Slider
	$('.temas_slider_JS').slick({
		dots: false,
		speed: 300,
		infinite: true,
		slidesToShow: 1,
		adaptiveHeight: true,
		prevArrow: $('.temas_slider_prev_JS'),
		nextArrow: $('.temas_slider_next_JS')
	});

	// Popup
	$('a[href="#datos-abiertos"]').click(function () {
		$('.popup_JS').fadeIn('fast')
	})
	$('.popup_close_JS').click(function () {
		$('.popup_JS').fadeOut('fast')
	})

	// FAQ
	$('.faq_item_JS:not(.active) .faq_txt_JS').slideUp(0)
	$('.faq_btn_JS').click(function () {
		if ($(this).closest('.faq_item_JS').hasClass('active')) {
			return
		}
		$('.faq_txt_JS').slideUp('fast')
		$('.faq_item_JS').removeClass('active')
		$(this).closest('.faq_item_JS').addClass('active').find('.faq_txt_JS').slideDown('fast')
	})

})
